import {loginUser} from '@/api'
import {setToken,saveUser,removeUser,removeToken} from '@/utils/user'

const user = {
    state: {
        userId:''
    },
    
    mutations: {
        SET_USER_ID: (state, userId) => {
            state.userId = userId
        }
    },
    
    actions: {
        
        Login({commit}, user) {
            return new Promise((resolve, reject) => {
                loginUser(user).then(res => {
                   
                    if (res && res !== null) {
                        saveUser({
                            token:res.token,
                            userId:res.userId,
                        })
                        setToken(res.token);
                        resolve(res)
                    } else {
                        reject(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
        
        // 登出
        LogOut({commit, state}) {
            return new Promise((resolve, reject) => {
                removeUser();
                removeToken();
                resolve()
            })
        },
    }
}

export default user
